export default __webpack_public_path__ + "static/media/cookie.728e94a8.JPG";